<template>
    <div class="profile">
        <CircleWrap @click.native="clickProfile">
            <div v-if="fbID && fbID !== ''" class="fb-image">
                <img v-if="fbImg" :src="fbImg" />
            </div>
            <div v-else class="un-signed">
                <UnSigned />
            </div>
        </CircleWrap>
    </div>
</template>

<script>
    import UnSigned from "@/assets/icons/unsigned.svg"
    import CircleWrap from "@/components/CircleWrap";
    import {mapState} from "vuex";
	export default {
		name: "Profile.vue",
        computed: {
	        ...mapState('ux', {
		        fbID: state => state.fbID
	        }),
            fbImg(){
	        	if(this.fbID){
			        return 'https://graph.facebook.com/'+this.fbID+'/picture?width=256&height=256&type=square'
                }
	            return false
            }
        },
        methods: {
			clickProfile(){
				let value = (!this.fbID) ? 'fb-signin' : 'fb-signout'
				this.$store.commit('ux/setGuideState', value)
            }
        },
        components: {
	        CircleWrap,
			UnSigned
        }
	}
</script>

<style lang="scss" scoped>
    .profile{
        position: absolute;
        z-index: 10;
        .circle{
            position: fixed;
            top: 15px;
            right: 15px;
            img{
                display: block;
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }
    }
</style>
